
<form [formGroup]="getProductDetailForm()">
    <div class="p-4 pt-2">
        <div class="row border-bottom pb-2 mb-2">
            <div class="col-10 mogo-header-2 text-start">
                Products
            </div>
            <div class="col-2 text-md-end">
                <button class="btn btn-primary" [disabled]="lockdown" (click)="addProduct()">Add Product</button>
            </div>
        </div>
        <table class="table table-striped">
            <thead >
                <tr>
                    <th class="col mogo-bold text-start">#</th>
                    <th class="col mogo-bold w-25 text-start">Category</th>
                    <th class="col mogo-bold w-25 text-start">Description</th>
                    <th class="col mogo-bold text-start">Quantity</th>
                    <th class="col mogo-bold text-start">Weight (Kg)</th>
                    <th class="col mogo-bold text-start">Volume (m3)</th>
                    <th class="col mogo-bold text-start w-25">Dangerous Goods</th>
                    <th class="col mogo-bold text-start"></th>
                </tr>
            </thead>
            <tbody formArrayName="products">
                    @if(getProductList() !== null && getProductList().controls.length > 0){
                        @for(product of getProductList().controls; track $index){

                            <tr [formGroupName]="$index" >
                                <th class="pt-3" scope="row">{{ $index + 1 }}</th>
                                <td>
                                    <ng-select
                                        [readonly]="lockdown"
                                        [items]="productCategories"
                                        bindLabel="name"
                                        bindValue="productCategoryId"
                                        [compareWith]="compareWithCategory"
                                        (change)="onProductCategoryChange($event, $index)"
                                        formControlName="category">
                                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                          <div class="text-md-start">
                                            {{ item.name }}
                                          </div>
                                      </ng-template>
                                    </ng-select>
                                </td>
                                <td>
                                    <ng-select #select
                                        [readonly]="lockdown"
                                        [items]="getProductDescriptionOptions($index)"
                                        bindLabel="name"
                                        [compareWith]="compareWith"
                                        bindValue="productId"
                                        formControlName="description"
                                        [addTag]="getProductDescriptionOptions($index).length > 0 ? createNewProductDescriptionTagFunction : false"
                                        (focus)="focusedProductDescriptionInput($index)"
                                        (change)="onProductDescriptionChange($event, $index)"
                                        (close)="focusedProductDescriptionInput(null)">
                                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                          <div class="text-md-start">
                                            {{ item.name }}
                                          </div>
                                      </ng-template>
                                        <ng-template ng-tag-tmp let-search="searchTerm">

                                            <button class="btn btn-primary">
                                                <i class="bi bi-plus"></i> Create
                                            </button>

                                        </ng-template>
                                    </ng-select>

                                </td>
                                <td>
                                    <input id="quantity-input" type="number" class="form-control" formControlName="quantity" placeholder="Quantity" inputmode="numeric"/>
                                </td>
                                <td>
                                    <input id="weightKg-input" type="number" class="form-control" formControlName="weightKg" placeholder="WeightKg" />
                                </td>
                                <td>
                                    <input id="volumeM3-input" type="number" class="form-control" formControlName="volumeM3" placeholder="VolumeM3" />
                                </td>
                                <td>
                                    <ng-select
                                        [readonly]="lockdown"
                                        [items]="dangerousProductCodes"
                                        bindLabel="alias"
                                        bindValue="id"
                                        formControlName="dangerousGoodsCode"
                                        >
                                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                          <div class="text-md-start">
                                            {{ item.alias }}
                                          </div>
                                      </ng-template>
                                    </ng-select>
                                </td>
                                <td>
                                    <button class="btn btn-danger" [disabled]="lockdown" (click)="removeProduct($index)"> - </button>
                                </td>
                            </tr>
                        }
                    }
            </tbody>
        </table>
        @if(getProductList() !== null && getProductList().controls.length === 0){
            <div class="row mt-2">
                <div class="col-12">
                    Currently no products added
                </div>
            </div>
        }
    </div>
</form>
